<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                A2P Registration
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8 shadow sm:rounded-md bg-white">
                <jet-form-section @submitted="saveProgress">
                    <template #title>
                        Review
                    </template>

                    <template #form>
                        <div class="col-span-6">
                            <label class="flex flex-col">
                                <div>
                                    Business Information
                                </div>
                                <div class="font-light text-gray-600">
                                    <div class='label'>
                                        {{$page.props.a2p.legal_business_name}}
                                        <template v-if="$page.props.a2p.dba_name">
                                            D.B.A. {{$page.props.a2p.dba_name}}
                                        </template>
                                    </div>
                                    <div class="label">Type: <span class='value'>{{$page.props.a2p.business_type}}</span></div>
                                    
                                    <div class='label' v-if="$page.props.a2p.website_url">Website: <span class='value'>{{$page.props.a2p.website_url}}</span> </div>
                                    <div class="label" v-if="$page.props.a2p.website_url">Social URLs: <span class='value'>{{$page.props.a2p.social_media_urls}}</span></div>
                                    <div class='label'>Industry: <span class='value'>{{$page.props.a2p.industry.toLowerCase()}}</span> </div>
                                    <div class='label'>Company Type: <span class='value'>{{$page.props.a2p.company_type}}</span></div>
                                    <div class='label'>Registration Number: <span class='value'>{{$page.props.a2p.registration_number}}</span></div>
                                    <div class="label" v-if="$page.props.a2p.ticker">Ticker: <span class='value'>{{$page.props.a2p.ticker}}</span></div>
                                    <div class="label" v-if="$page.props.a2p.stock_exchange">Stock Exchange: <span class='value'>{{$page.props.a2p.stock_exchange}}</span></div>
                                </div>
                            </label>
                        </div>
                        <div class="col-span-6">
                            <label class="flex flex-col">
                                <div>
                                    Business Address
                                </div>
                                <div class="font-light text-gray-600">
                                    {{$page.props.a2p.street}}
                                    <br />
                                    {{$page.props.a2p.city}}, {{$page.props.a2p.state}} {{$page.props.a2p.postal_code}}
                                </div>
                            </label>
                        </div>
                        <div class="col-span-6">
                            <label class="flex flex-col">
                                <div>
                                    Contact Information
                                </div>
                                <div class="font-light text-gray-600">
                                    {{$page.props.a2p.authorized_rep_first_name}} {{$page.props.a2p.authorized_rep_last_name}}
                                    <br />
                                    {{$page.props.a2p.authorized_rep_job_title}}
                                    <br />
                                    {{$page.props.a2p.authorized_rep_email}}
                                    <br />
                                    {{$page.props.a2p.authorized_rep_phone_number}}
                                    <br />
                                </div>
                            </label>
                        </div>
                        <div class="col-span-6">
                            <label class="flex flex-col">
                                <div>
                                    Messaging
                                </div>
                                <div class="font-light text-gray-600">
                                    <div class='label'>Use Case: <span class='value'>{{messagingUseCases}}</span></div>
                                    <div class='label'>Example Messages: </div>
                                    <div class='value' v-for="example in exampleMessages">
                                        {{example}}
                                    </div>
                                    <div class='label'>Consent Optin: </div>
                                    <div class="value">
                                        {{ $page.props.a2p.optin_message_flow }}
                                    </div>
                                    
                                </div>
                            </label>
                        </div>
                        <div class="col-span-6">
                            <div class="border-2 border-orange-400 bg-orange-100 p-4 rounded-lg mb-4 mt-4">
                                Your card on file will be charged $19 as a one-time fee.<br />
                                Falsified information may jeopardize your registration and the cost will not be refunded.
                            </div>
                        </div>
                    </template>
                    <template #actions>
                        
                        <Link :href="route('a2p.step6')" class="mr-auto" >
                            <jet-button secondary type="button">
                                Back
                            </jet-button>
                        </Link>

                        <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                            Saved.
                        </jet-action-message>

                        <jet-button
                            :class="{ 'opacity-25': form.processing }"
                            :disabled="!goodToContinue"
                        >
                            Submit Registration for $19
                        </jet-button>

                        
                    </template>
                </jet-form-section>
                
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "./../../Jetstream/Button";
import JetFormSection from "./../../Jetstream/FormSection";
import JetInput from "./../../Jetstream/Input";
import JetInputError from "./../../Jetstream/InputError";
import JetLabel from "./../../Jetstream/Label";
import JetActionMessage from "./../../Jetstream/ActionMessage";
import JetSecondaryButton from "./../../Jetstream/SecondaryButton";

import exampleSelectable from "../../components/A2p/ExampleSelectable";

export default {
    name: 'A2P-Review',
    props: [],
    components: {
        AppLayout,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        
        //vSelect,
        exampleSelectable,
    },
    data() {
        return {
            form: this.$inertia.form(
                {
                    _method: "POST",
                    step: 'review',
                },
                {
                }
            ),
        }
    },
    computed: {
        goodToContinue() {
            return true;
        },
        messagingUseCases() {
            let useCases = "";
            for (let prop in this.$page.props.a2p.message_types) {
                if (this.$page.props.a2p.message_types[prop]) {
                    if (useCases) {
                        useCases = useCases + ", " + prop;
                    } else {
                        useCases = prop;
                    }
                }
            }
            return useCases;
        },
        exampleMessages() {
            let exampleMessages = [];
            for (let prop in this.$page.props.a2p.example_messages) {
                if (this.$page.props.a2p.example_messages[prop]) {
                    exampleMessages.push(this.$page.props.a2p.example_messages[prop]);
                }
            }
            return exampleMessages;
        }
       
    },
    mounted() {

    },
    methods: {
        saveProgress() {

            this.form.post("/verified/save-progress", {
                preserveScroll: true,
                onSuccess: (response) => {
                    
                },
            });
        },
    },
    watch: {
    }

};
</script>

<style lang="scss" scoped>

.required {
    @apply text-red-500 font-bold text-xl pl-1;
}

.label {
    @apply font-bold text-gray-700;
}

.value {
    @apply font-light text-gray-600;
}

</style>
